import { useState } from 'react';

import { Box, Button } from '@mui/material';
import { REALADVISOR_TENANT_ID } from '@realadvisor/constants';
import { Wand2 } from 'lucide-react';

import { AutoAssignAssistantCH } from '@modules/_shared/components/AutoAssignAssistantCH';
import { AutoAssignAssistantEU } from '@modules/_shared/components/AutoAssignAssistantEU';
import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';
import { isRATenantId } from '@shared/utils/tenant';

interface Props {
  leadId?: string;
  tenantId?: string;
}

export const AutoAssignAssistant = ({ leadId, tenantId }: Props) => {
  const [open, setOpen] = useState(false);
  const { t } = useLocale();

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="soft"
        startIcon={<Wand2 />}
        disabled={!leadId || !tenantId}
        sx={{ flex: 1 }}
      >
        {t('Assign assistant')}
      </Button>
      <SlideDialog
        open={open}
        onClose={() => setOpen(false)}
        title={t('Assign assistant')}
        maxWidth="lg"
      >
        <Box sx={{ p: 2 }}>
          {
            // All RA tenants but CH
            tenantId &&
              leadId &&
              isRATenantId(tenantId) &&
              tenantId !== REALADVISOR_TENANT_ID && (
                <AutoAssignAssistantEU leadId={leadId} />
              )
          }
          {
            // Only for RA CH tenant
            leadId && tenantId === REALADVISOR_TENANT_ID && (
              <AutoAssignAssistantCH leadId={leadId} />
            )
          }
        </Box>
      </SlideDialog>
    </>
  );
};
